<!-- eslint-disable -->
<template lang="pug">
    .game-content(
        v-if="playersNumber"
    )
        games-wrapper(
            :type="type"
            :exercise-id="exerciseId"
            :homework-id="homeworkId"
            :players-number="playersNumber"
            :check-multiplayer-answers="checkMultiplayerAnswers"
            :play-again="playAgain"
            @playAgainReady="$event ? playAgainReadyScreens++ : playAgainReadyScreens--"
            @checkAnswersReady="$event ? checkAnswersReadyScreens++ : checkAnswersReadyScreens--"
        )
</template>

<script>
    /*eslint-disable*/
import PlayBox from './PlayBox.vue'
import {mapState} from 'vuex'
import MultiScreenButtons from '../../MultiScreenButtons.vue';
import GamesWrapper from '../GamesWrapper.vue'

export default {
    props: ['exerciseId', 'homeworkId', 'type'],
    data () {
        return {
            checkMultiplayerAnswers: false,
            playAgain: false,
            playAgainReadyScreens: 0,
            checkAnswersReadyScreens: 0
        }
    },
    methods: {
        sendCheckMultiplayerAnswersEvent () {
            this.checkMultiplayerAnswers = true;
            this.$nextTick(() => {
                this.checkMultiplayerAnswers = false;
            });
        },
        sendPlayAgainEvent () {
            this.playAgain = true;
            this.$nextTick(() => {
                this.playAgain = false;
            });
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            paramsArray: state => state.trainer.paramsArray
        }),
        playersNumber () {
            return this.paramsArray ? this.paramsArray.length : 1;
        }
    },
    components: {
        PlayBox,
        MultiScreenButtons,
        GamesWrapper
    },
    beforeRouteLeave (to, from, next) {
        if (this.$store.state.trainer.game) {
            if (!(to.meta.type && to.meta.type === 'trainer')) {
                this.$store.dispatch('setHomework', null);
                this.$store.dispatch('setGame', null);
            }
        }
        next();
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/main.scss";
</style>
